import { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import { DesignSeriesBreadcrumbs_iconicDesignSeriesPage$data } from './__generated__/DesignSeriesBreadcrumbs_iconicDesignSeriesPage.graphql';

import styles from './DesignSeriesBreadcrumbs.scss';

type Props = {
    iconicDesignSeriesPage: DesignSeriesBreadcrumbs_iconicDesignSeriesPage$data;
};

const DesignSeriesBreadcrumbsComponent: FC<Props> = ({ iconicDesignSeriesPage }) => {
    const { title } = iconicDesignSeriesPage?.cmsTopModule || {};

    return (
        <div className={styles.container}>
            <Link className={styles.link} href={'/'}>
                <FormattedMessage id="designs.designSeriesBreadcrumbs.home" defaultMessage="Home" />
            </Link>
            <Link className={styles.link} href={'/designs'}>
                <FormattedMessage
                    id="designSeries.DesignSeriesBreadcrumbs.series"
                    defaultMessage="Design Series"
                />
            </Link>
            <span className={styles.lastChild}>{title}</span>
        </div>
    );
};

export const DesignSeriesBreadcrumbs = createFragmentContainer(DesignSeriesBreadcrumbsComponent, {
    iconicDesignSeriesPage: graphql`
        fragment DesignSeriesBreadcrumbs_iconicDesignSeriesPage on IconicDesignSeriesPage {
            cmsTopModule {
                title
            }
        }
    `,
});
